<template>
  <div>
    <div>
      <v-btn outline color="primary" :disabled="dataList.length === 0" @click="handleExportXlsx">
        <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="dataList"
      class="elevation-1 mt-3"
      :pagination.sync="pagination"
    >
      <template #items="props">
        <tr>
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.id || '-' }}</td>
          <td>
            <span v-if="props.item.app == 'facebook'" style="color: #3b5998">
              <em class="fab fa-facebook-square" />
            </span>
            <span v-else-if="props.item.app == 'line'" style="color: #00c300">
              <em class="fab fa-line" />
            </span>
          </td>
          <td>{{ props.item.pagename || '-' }}</td>
          <td>{{ transformToTime(props.item.transaction_order_complete_time) || '-' }}</td>

          <td>{{ props.item.order_updated_at | DateFormat('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ props.item.shipping_address_json.province || '-' }}</td>
          <td>{{ props.item.status || '-' }}</td>
          <td>
            <v-btn flat icon small color="primary" @click="handleShowOrderDetail(props.item)">
              <em class="fas fa-list" />
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="showDialogOrderDetail" width="1000px">
      <DialogOrderDetail
        v-if="showDialogOrderDetail && selectedOrder"
        v-model="selectedOrder"
        @close="
          selectedOrder = null
          showDialogOrderDetail = false
        "
      ></DialogOrderDetail>
    </v-dialog>
    <!-- <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pagelength"
            @input="handleChangePage"
          ></v-pagination>
        </div> -->
  </div>
</template>

<script>
import DialogOrderDetail from './DialogOrderDetail.vue'
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'

export default {
  components: {
    DialogOrderDetail
  },
  props: ['value'],
  data() {
    return {
      pagination: { sortBy: '', descending: true, rowsPerPage: 10 },
      dataList: [],
      headers: [
        { text: 'No.', value: '', sortable: false },
        { text: 'Order ID', value: 'id', sortable: false },
        { text: 'ช่องทาง', value: 'app', sortable: false },
        { text: 'เพจ', value: 'pagename', sortable: false },
        {
          text: 'เวลาเฉลี่ยในการทำรายการ',
          value: 'transaction_order_complete_time',
          sortable: false
        },
        { text: 'เวลาอัพเดท', value: 'order_updated_at', sortable: false },
        { text: 'จังหวัด', value: 'shipping_address_json', sortable: false },
        { text: 'สถานะ', value: 'status', sortable: false },
        { text: 'รายการสั่งซื้อ', value: '', sortable: false }
      ],
      showDialogOrderDetail: false,
      selectedOrder: null
    }
  },
  watch: {
    value: {
      handler() {
        this.dataList = this.value
      },
      deep: true
    }
  },
  mounted() {
    if (this.value) {
      this.dataList = this.value
    }
  },
  methods: {
    handleShowOrderDetail(order) {
      this.selectedOrder = order
      this.showDialogOrderDetail = true
    },
    handleExportXlsx() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const data = vm.dataList
        if (data == null) return
        const requests = data.map((el, index) => {
          return {
            no: index + 1,
            order_id: el.id,
            channel: el.app,
            page_name: el.pagename,
            transaction_order_complete_time: vm.transformToTime(el.transaction_order_complete_time),
            update_time: dayjs(el.order_updated_at).format('DD/MM/YYYY HH:mm'),
            province: el.shipping_address_json.province,
            status: el.status
          }
        })

        const heading = [
          [
            'No.',
            'Order ID',
            'ช่องทาง',
            'เพจ',
            'เวลาเฉลี่ยในการทำรายการ',
            'เวลาอัพเดท',
            'จังหวัด',
            'สถานะ'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `report-order-statistics-orders.xlsx`)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    transformToTime(time) {
      const tempTime = Number(time)
      const hour = Math.floor(tempTime / 3600)
      const minute = Math.floor((tempTime % 3600) / 60)
      const second = Math.floor((tempTime % 3600) % 60)

      const hDisplay = hour > 0 ? `${hour} ชั่วโมง` : ''
      const mDisplay = minute > 0 ? ` ${minute} นาที` : ''
      const sDisplay = second > 0 ? ` ${second} วินาที` : ''
      return `${hDisplay} ${mDisplay} ${sDisplay}`
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/OrderStatistics/OrderStatisticsList.vue